import { CamelCasedPropertiesDeep } from "type-fest";
// Type-only: a real import builds every openapi-fetch client at module load
import type { ClientOutput } from "../client";

export type TermsAndConditions = CamelCasedPropertiesDeep<
  ClientOutput["auth"]["TermsAndConditions"]
>;
export type UnifiedTermsAndConditions = CamelCasedPropertiesDeep<
  ClientOutput["auth"]["UnifiedTermsAndConditions"]
>;

export type TermsCategory = TermsAndConditions["category"];

const PLATFORM_KEYS = ["product", "website", "marketplace", "privacy"] as const;
const POLICY_KEYS = [...PLATFORM_KEYS, "nominated"] as const;

const isOutstanding = (policy?: TermsAndConditions | null) =>
  policy?.needsToAccept === true;

/**
 * The policies the user still has to accept, in display order. Use this over the
 * legacy `requiresTerms`/`termsAccepted` flags, which a different flow writes.
 */
export const outstandingTerms = (
  terms?: UnifiedTermsAndConditions | null
): TermsAndConditions[] =>
  POLICY_KEYS.map((key) => terms?.[key]).filter(
    (policy): policy is TermsAndConditions => isOutstanding(policy)
  );

export const hasOutstandingPlatformTerms = (
  terms?: UnifiedTermsAndConditions | null
) => PLATFORM_KEYS.some((key) => isOutstanding(terms?.[key]));

export const hasOutstandingNominatedTerms = (
  terms?: UnifiedTermsAndConditions | null
) => isOutstanding(terms?.nominated);
